import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc, query, where, orderBy, onSnapshot, serverTimestamp } from "firebase/firestore";

export default function Withdrawal({ user, wallet }) {
  const [tab, setTab] = useState("request");
  const [method, setMethod] = useState("bank");
  const [amount, setAmount] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const [iban, setIban] = useState("");
  const [ethAddress, setEthAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const q = query(
      collection(db, "withdrawals"),
      where("userId", "==", user.uid),
      orderBy("createdAt", "desc")
    );
    const unsub = onSnapshot(q, snap => {
      setHistory(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return unsub;
  }, [user]);

  const handleSubmit = async () => {
    if (!amount || Number(amount) < 10) { setMsg("Minimum withdrawal is $10"); return; }
    if (Number(amount) > (wallet?.balance || 0)) { setMsg("Insufficient balance"); return; }
    if (method === "bank" && (!bankName || !accountNumber || !accountName)) {
      setMsg("Please fill all bank details"); return;
    }
    if (method === "crypto" && !ethAddress) {
      setMsg("Please enter your ETH wallet address"); return;
    }
    setLoading(true); setMsg("");
    try {
      await addDoc(collection(db, "withdrawals"), {
        userId: user.uid,
        email: user.email,
        amount: Number(amount),
        method,
        bankName: method === "bank" ? bankName : "",
        accountNumber: method === "bank" ? accountNumber : "",
        accountName: method === "bank" ? accountName : "",
        swiftCode: method === "bank" ? swiftCode : "",
        iban: method === "bank" ? iban : "",
        ethAddress: method === "crypto" ? ethAddress : "",
        status: "pending",
        createdAt: serverTimestamp(),
      });
      setMsg("✓ Withdrawal request submitted! Admin will process within 1-3 business days.");
      setAmount(""); setBankName(""); setAccountNumber("");
      setAccountName(""); setSwiftCode(""); setIban(""); setEthAddress("");
    } catch (e) {
      setMsg("Error: " + e.message);
    }
    setLoading(false);
  };

  return (
    <div className="deposit-page">
      <div className="dep-header">
        <div className="dep-page-title">Withdrawal</div>
      </div>

      <div className="dep-tabs">
        <div className={`dep-tab ${tab === "request" ? "active" : ""}`} onClick={() => setTab("request")}>
          💸 Request Withdrawal
        </div>
        <div className={`dep-tab ${tab === "history" ? "active" : ""}`} onClick={() => setTab("history")}>
          📋 Withdrawal History
        </div>
      </div>

      <div className="dep-content">
        {tab === "request" && (
          <div className="dep-panel">
            <div className="dep-panel-title">Request Withdrawal</div>
            <div className="dep-panel-sub">Available balance: <strong style={{color:"#F0A500"}}>${wallet?.balance?.toFixed(2) || "0.00"}</strong></div>

            <label className="dep-label">Withdrawal Method</label>
            <div className="direction-row">
              <div className={`dir-btn ${method === "bank" ? "active buy" : ""}`} onClick={() => setMethod("bank")}>🏦 Bank Transfer</div>
              <div className={`dir-btn ${method === "crypto" ? "active buy" : ""}`} onClick={() => setMethod("crypto")}>⟠ Crypto ETH</div>
            </div>

            <label className="dep-label">Amount (USD)</label>
            <input className="inp" type="number" placeholder="Minimum $10" value={amount} onChange={e => setAmount(e.target.value)} />

            {method === "bank" && (
              <>
                <label className="dep-label">Bank Name</label>
                <input className="inp" placeholder="e.g. BCA, HSBC, Barclays" value={bankName} onChange={e => setBankName(e.target.value)} />
                <label className="dep-label">Account Holder Name</label>
                <input className="inp" placeholder="Full name as per bank account" value={accountName} onChange={e => setAccountName(e.target.value)} />
                <label className="dep-label">Account Number / IBAN</label>
                <input className="inp" placeholder="Account number or IBAN" value={accountNumber} onChange={e => setAccountNumber(e.target.value)} />
                <label className="dep-label">SWIFT / BIC Code <span style={{color:"#5A6480"}}>(required for international)</span></label>
                <input className="inp" placeholder="e.g. CENAIDJA" value={swiftCode} onChange={e => setSwiftCode(e.target.value)} />
                <label className="dep-label">IBAN <span style={{color:"#5A6480"}}>(if applicable)</span></label>
                <input className="inp" placeholder="e.g. GB29NWBK60161331926819" value={iban} onChange={e => setIban(e.target.value)} />
              </>
            )}

            {method === "crypto" && (
              <>
                <label className="dep-label">Your ETH Wallet Address</label>
                <input className="inp" placeholder="0x..." value={ethAddress} onChange={e => setEthAddress(e.target.value)} />
                <div style={{fontSize:"11px", color:"#5A6480"}}>Make sure the address is correct. Crypto withdrawals are irreversible.</div>
              </>
            )}

            {msg && (
              <div className="dep-msg" style={{
                color: msg.includes("✓") ? "#00C896" : "#FF3B5C",
                background: msg.includes("✓") ? "rgba(0,200,150,0.08)" : "rgba(255,59,92,0.08)"
              }}>{msg}</div>
            )}

            <button className="btn-main btn-full" onClick={handleSubmit} disabled={loading}>
              {loading ? "Submitting..." : "Submit Withdrawal Request"}
            </button>

            <div className="dep-secure">
              ⚠️ Withdrawals are processed within 1-3 business days after admin approval.
            </div>
          </div>
        )}

        {tab === "history" && (
          <div>
            {history.length === 0 ? (
              <div style={{textAlign:"center", color:"#5A6480", padding:"60px"}}>No withdrawal history</div>
            ) : (
              <table style={{width:"100%", borderCollapse:"collapse", fontSize:"13px"}}>
                <thead>
                  <tr>
                    {["Amount","Method","Status","Reason","Date"].map(h => (
                      <th key={h} style={{textAlign:"left", padding:"8px 12px", fontSize:"10px", letterSpacing:"1px", textTransform:"uppercase", color:"#5A6480", borderBottom:"1px solid #1E2840"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {history.map(w => (
                    <tr key={w.id}>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840", fontFamily:"monospace", fontWeight:"700", color:"#FF3B5C"}}>
                        -${w.amount?.toFixed(2)}
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840"}}>
                        {w.method === "bank" ? "🏦 Bank" : "⟠ ETH"}
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840"}}>
                        <span style={{
                          padding:"3px 8px", borderRadius:"4px", fontSize:"10px", fontWeight:"700",
                          background: w.status === "pending" ? "rgba(240,165,0,0.12)" : w.status === "approved" ? "rgba(0,200,150,0.12)" : "rgba(255,59,92,0.12)",
                          color: w.status === "pending" ? "#F0A500" : w.status === "approved" ? "#00C896" : "#FF3B5C"
                        }}>{w.status}</span>
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840", fontSize:"11px", color:"#FF3B5C"}}>
                        {w.rejectReason || "-"}
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840", color:"#5A6480", fontSize:"11px"}}>
                        {w.createdAt?.toDate ? w.createdAt.toDate().toLocaleDateString() : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
}